<script lang="ts">
	import FullVideoList from '$lib/components/platform/pages/videos/VideoList.svelte';
	import Meta from '$lib/components/Meta.svelte';
	import { page } from '$app/stores';
	import SearchVideos from '$lib/components/platform/SearchVideos.svelte';
	import VimeoCarousel from '$lib/components/VimeoCarousel.svelte';
	import { onMount } from 'svelte';
	import { get } from 'svelte/store';
	import { getPlaylists } from '$lib/utils/api';
	import VideoFilterBtnList from '$lib/components/platform/VideoFilterBtnList.svelte';

	export let data;

	let playlistItems = [];
	let currentPage = 1;
	let loading = false;
	let hasMore = true;
	let observer: IntersectionObserver;
	let loadMoreTrigger: HTMLDivElement;

	$: search = $page.url.searchParams.get('search') && $page.url.searchParams.get('search') !== '';
	$: hasParameters = $page.url.search !== '';

	onMount(async () => {
		playlistItems = data.playlists.data;
		hasMore = playlistItems.length < data.playlists.count;

		console.log('playlistItems', playlistItems);

		observer = new IntersectionObserver(handleIntersection, {
			root: null,
			rootMargin: '0px',
			threshold: 0.1
		});

		if (loadMoreTrigger) {
			observer.observe(loadMoreTrigger);
		}

		return () => {
			if (observer) {
				observer.disconnect();
			}
		};
	});

	async function loadMorePlaylists() {
		if (loading || !hasMore) return;

		loading = true;
		currentPage++;

		const { balancedSupabase, user } = $page.data;
		const start = (currentPage - 1) * 5;
		const end = currentPage * 5 - 1;

		const result = await getPlaylists(balancedSupabase, user, start, end);

		if (result.data.length > 0) {
			playlistItems = [...playlistItems, ...result.data];
			hasMore = playlistItems.length < result.count;
		} else {
			hasMore = false;
		}

		loading = false;
	}

	function handleIntersection(entries: IntersectionObserverEntry[]) {
		const entry = entries[0];
		if (entry.isIntersecting) {
			loadMorePlaylists();
		}
	}
</script>

<Meta
	title={data.page.title}
	description={data.page.description}
	image={data.page.public_image_url}
/>

<div class="flex flex-col items-start justify-start gap-4">
	<VideoFilterBtnList sectors={data.sectors} class="mb-16" />
</div>

<main class="mt-8 px-6">
	<div class="bg-white">
		<div
			class="space-y-6 pb-6 sm:space-y-8 sm:pb-8 md:space-y-10 md:pb-10 lg:space-y-16 lg:pb-16 xl:space-y-20 xl:pb-20"
		>
			{#each playlistItems as playlist}
				<VimeoCarousel title={playlist.name} videos={playlist.videos} {playlist} />
			{/each}

			{#if loading}
				<div class="text-center">Loading more playlists...</div>
			{/if}

			{#if hasMore}
				<div bind:this={loadMoreTrigger} class="h-10" />
			{/if}
		</div>
	</div>
</main>
